<template>
  <div class="elunittree">
    <!-- 新的Element多选设备树形控件 -->
    <div style="margin-bottom: 5px;">
      <el-input
        size="medium"
        placeholder="输入关键字进行过滤"
        v-model="filterText"
      >
      </el-input>
    </div>

    <el-scrollbar style="height:calc(100% - 55px);width: 100%;">
      <el-tree
        class="filter-tree"
        show-checkbox
        :data="dataList"
        highlight-current
        :filter-node-method="filterNode"
        ref="tree"
        @check="tree_fn"
        auto-expand-parent
        :props="defaultProps"
        node-key="no"
        check-on-click-node
        :default-expanded-keys="checkedData"
        :default-checked-keys="[-246]"
      >
        <template #default="{ node,data }">
          <span class="custom-tree-node">
            <img
              src="../../../../public/static/image/elTree/1.9.png"
              v-if="data.entityName == 'AppClassType'"
            />
            <img src="../../../../public/static/image/elTree/111.png" v-else />
            {{ node.label }}
          </span>
        </template>
      </el-tree>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  props: ["dataList"],
  data() {
    return {
      filterText: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      checkedData: [],
    };
  },

  mounted() {
    this.digui(this.dataList);
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    // virtualDeviceList(){}
    dataList(val) {
      this.digui(val);
    },
  },
  computed: {
    //   virtualDeviceList() {
    // 	var data = this.$store.deviceStore.getters.getReadDeviceTree
    // 	return isempty(data) ? [] : [deviceList(data)]
    // },
  },

  methods: {
    // 树形筛选
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    tree_fn(v, val) {
      var data = [];
      val.checkedNodes.forEach((item) => {
        if (item.entityName == "VirtualDevicePojo") {
          data.push(item);
        }
      });
      this.$emit("checkFun", data);
    },
    digui(data) {
      var device = [];
      var recursiveFunction = function() {
        const getStr = function(list) {
          list.forEach(function(row) {
            if (row.hasOwnProperty("children") && row.children.length != 0) {
              getStr(row.children);
            } else {
              device.push(row);
            }
          });
        };
        getStr(data);
      };
      recursiveFunction();
      this.checkedData = [device[0].no];
      this.$nextTick(() => {
        //默认选中
        // this.$refs['tree'].setCheckedNodes([device[0]]);
        // this.$emit('checkFun',[device[0]]);
      });
    },
  },
};
</script>
<style>
.elunittree .el-checkbox__inner {
  border-color: #000;
}
</style>

<style lang="scss" scoped>
.elunittree {
  width: 100%;
  height: 100%;

  .custom-tree-node {
    display: flex;
    align-items: center;

    img {
      margin-right: 5px;
    }
  }
}
</style>
